




























import { Component, Vue } from 'vue-property-decorator';
import PremimumCardFree from '@/main-components/premium/premium-cards/PremimumCardFree.vue';
import PremimumCardOne from '@/main-components/premium/premium-cards/PremimumCardOne.vue';
import PremimumCardSix from '@/main-components/premium/premium-cards/PremimumCardSix.vue';
import MainTitle from '@/components/common/MainTitle.vue';
import MainParagraph from '@/components/common/MainParagraph.vue';
import PremiumDiscount from './PremiumDiscount.vue';

@Component({
  components: {
    PremimumCardFree,
    PremimumCardOne,
    PremimumCardSix,
    PremiumDiscount,
    MainTitle,
    MainParagraph,
  },
})
export default class PremiumDisplay extends Vue {
  thirdTitle = [
    {
      type: 'normal',
      value: 'Jadi ahli ',
    },
    {
      type: 'highlight',
      value: 'Premium',
    },
    {
      type: 'normal',
      value: ' atau cuba Mysoalan secara percuma',
    },
  ];

  thridP = `Pilih pelan terbaik untuk anda atau cuba Mysoalan secara percuma tanpa bayaran dan tiada maklumat kad kredit diperlukan.`;

  onWhatsappLinkClick() {
    this.$sendMpEvent({
      event: this.$mp_value.SubscriptionWhatsapp,
    });

    this.$sendMpEvent;
    window.open('https://wa.me/601159951420', '_blank');
  }
}
